import dayjs from "dayjs";
import { wait } from "../../utils/mock";
import { monthNames } from "../../components/Calendar";

// TODO populate with data...

//TODO mock
const generateMonth = (year, month) => {
    //const { year, month } = fromMonthId(id);
    //const monthId = month;
    let d = dayjs().year(year).month(month).date(1);
    let calendar = {};
    let hours = 0;
    while (d.month() === month) {
        let day = d.day();
        if (day !== 0 && day !== 6) {
            let value = Math.random() * 12;
            hours += value;
            const dayData = {
                day,
                value,
            };
            calendar[d.format("YYYY-MM-DD")] = dayData;
        }
        d = d.add(1, "day");
    }
    return { id: month, name: monthNames[month], hours: Math.round(hours), calendar };
};

const generateWeek = (year, week) => {
    //const { year, month } = fromMonthId(id);
    //const monthId = month;
    let d = dayjs().year(year).isoWeek(week).startOf("isoWeek");
    let calendar = {};
    let hours = 0;
    while (d.isoWeek() === week) {
        let day = d.day();
        if (day !== 0 && day !== 6) {
            let value = Math.random() * 12;
            hours += value;
            const dayData = {
                day,
                value,
                items: new Array(4).map((_, key) => ({
                    name: `Položka ${++key}`,
                    projectName: `Projekt ${key}`,
                    duration: value,
                })),
            };
            calendar[d.format("YYYY-MM-DD")] = dayData;
        }
        d = d.add(1, "day");
    }
    return { id: week, hours: Math.round(hours), calendar };
};

export const fetchList = async ({ filter }) => {
    //TODO rewrite to objects
    const year = filter.year || 2025;
    const data = {
        year,
        months: {},
    };
    for (let i = 0; i < 12; i++) {
        data.months[i] = generateMonth(year, i);
    }

    await wait(1234);
    return data;
};

export const fetchDetail = async ({ type, date, filter }) => {
    //setDetail({});
    const d = dayjs(date);
    await wait(1300);

    if (type === "month") {
        let value = generateMonth(d.year(), d.month());
        return {
            ...value,
            projects: [
                { name: "Projekt 1", value: 1 },
                { name: "Projekt 2", value: 2 },
                { name: "Projekt 3", value: 3 },
                { name: "Projekt 4", value: 3 },
                { name: "Projekt 5", value: 3 },
            ],
        };
    }

    if (type === "isoWeek") {
        return {
            ...generateWeek(d.year(), d.isoWeek()),
            projects: [
                { name: "Projekt 1", value: 4 },
                { name: "Projekt 2", value: 3 },
                { name: "Projekt 3", value: 2 },
            ],
        };
    }

    return {};
};

export const storeTimesheet = async (data) => {
    await wait(3210);
    if (data.description === "exception") {
        //TODO throw exception
        throw new Error("error");
    }
};

export function toMonthId(year, month) {
    return `M-${year}-${month}`;
}

export function fromMonthId(id) {
    //TODO implement properly
    if (!id) {
        return {};
    }
    const [_, year, month] = id.split("-");
    return { year: year * 1, month: month * 1 };
}
